import { Meta } from "../../../meta/meta";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { GoBack } from "../../../components/ui/goBack";
import {
  getYouTubeEmbedUrl,
  removeFileExtensions,
} from "../../../utils/formatters";
import { getDownload } from "../../../utils/helpers";
import { FullScreenSlider } from "../../../components/fullScreenSlider/fullScreenSlider";
import { isNotEmptyArray, overflowCheck } from "../../../utils/checkers";
import { useTanstackById } from "../../../hooks/useTanstack";
import { useParams } from "react-router-dom";
import { Loader } from "../../../components/ui/loader";
import styles from "../../template/models/styles.module.scss";

const NewsModelOne = ({
  id,
  title_am,
  title_en,
  description_am,
  description_en,
  image,
}) => {
  const { t } = useTranslation();
  const { language } = useParams();
  const { data } = useTanstackById("getWebSingleNews", id);

  const title = language === "am" ? title_am : title_en;
  const description = language === "am" ? description_am : description_en;

  const [fullscreenImageIndex, setFullscreenImageIndex] = useState(0);
  const [fullscreenOpen, setFullscreenOpen] = useState(false);

  const openFullscreen = (index) => {
    setFullscreenImageIndex(index);
    setFullscreenOpen(true);
  };

  const closeFullscreen = () => {
    setFullscreenOpen(false);
  };

  overflowCheck(fullscreenOpen);

  return (
    <>
      <Meta title={title} description={description} image={image} />
      {!data ? (
        <Loader />
      ) : (
        <main className={styles.modelOne}>
          <div className="container">
            <div className={styles.modelOne_context}>
              <GoBack />

              <div
                className={styles.modelOne_main}
                style={{ flexDirection: "row" }}
              >
                <div className={styles.modelOne_main_column}>
                  {data?.images?.length ? (
                    <div className={styles.modelOne_main_column_img}>
                      <img
                        src={data?.images[0]}
                        alt="mianImg"
                        loading="lazy"
                        onClick={() => openFullscreen()}
                      />
                      <span
                        className={styles.modelOne_main_column_img_imageDate}
                      >
                        {data?.created}
                      </span>
                    </div>
                  ) : null}

                  <h1>{data?.title}</h1>

                  <div className={styles.modelOne_updateBlockSecond}>
                    <div className={styles.modelOne_updateSecond}>
                      <p>{t("update")}</p>
                      <span>{data?.updated}</span>
                    </div>
                  </div>

                  <div
                    className={styles.modelOne_main_column_text}
                    dangerouslySetInnerHTML={{ __html: data?.description }}
                  ></div>

                  {data?.files?.length ? (
                    <ul className={styles.model_files}>
                      {data?.files?.map(({ name, stored_name }) => {
                        return (
                          <li key={name} onClick={() => getDownload(name)}>
                            {removeFileExtensions(stored_name)}
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}

                  {isNotEmptyArray(data?.links) ? (
                    <ul className={styles.model_links}>
                      {data?.links?.map((el) => {
                        const isYouTubeLink =
                          el?.includes("youtube.com") ||
                          el?.includes("youtu.be");
                        const embedUrl = getYouTubeEmbedUrl(el);

                        return (
                          <li key={el}>
                            {isYouTubeLink ? (
                              <iframe
                                width="100%"
                                // width={mobile ? "100%" : "560"}
                                height="315"
                                src={embedUrl}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                title="YouTube video"
                              ></iframe>
                            ) : (
                              <a href={el} target="/blank" rel="noreferrer">
                                {el}
                              </a>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}
                  {/* {data?.images && data?.images?.length <= 3 && (
                <div className={styles.modelOne_main_column_imgs}>
                  {data.images.slice(1, 4).map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      alt="imgSmall"
                      loading="lazy"
                      onClick={() => openFullscreen(index + 1)}
                    />
                  ))}
                </div>
              )} */}

                  {data?.images &&
                    data?.images?.length > 2 &&
                    isNotEmptyArray(data?.images?.slice(1, 3)) && (
                      <div className={styles.modelOne_main_column_imgs}>
                        {data.images.slice(1, 3).map((image, index) => (
                          <img
                            key={index}
                            src={image}
                            alt="imgSmall"
                            loading="lazy"
                            onClick={() => openFullscreen(index + 1)}
                          />
                        ))}
                      </div>
                    )}

                  {data?.images?.length > 3 && (
                    <div className={styles.modelOne_main_column_more}>
                      <button
                        onClick={() => openFullscreen(3)}
                        type="button"
                        aria-label={t("more_photo")}
                      >
                        {t("more_photo")}
                      </button>
                    </div>
                  )}
                </div>

                <div className={styles.modelOne_updateBlockFirst}>
                  <div className={styles.modelOne_updateFirst}>
                    <p>{t("update")}</p>
                    <span>{data?.updated}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {fullscreenOpen && (
            <FullScreenSlider
              images={data?.images}
              startIndex={fullscreenImageIndex}
              setStartIndex={setFullscreenImageIndex}
              onClose={closeFullscreen}
            />
          )}
        </main>
      )}
    </>
  );
};

export default NewsModelOne;
